function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "gas-pump-diesel");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-297.000000, -792.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "section-filtros",
  transform: "translate(273.000000, 709.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "comboBox-Carburante",
  transform: "translate(20.000000, 78.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "gas-pump-diesel",
  transform: "translate(4.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(11.111111, 13.888889)",
  fill: "#415A6B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.91835922,0.262443661 L4.81217642,4.02493631 C4.81217642,4.44297472 5.13077459,4.75651578 5.55555556,4.75651578 C5.98033652,4.75651578 6.29893469,4.44297472 6.29893469,4.02493631 L6.35205098,0.314716833 L4.91835922,0.262443661 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.28116288,5.48814423 L2.26339108,2.45723104 L2.79440462,0.105673133 L0.139436479,0.00117577895 L0.139436479,0.00117577895 C-0.0729788929,0.785028415 0.0863201912,1.6733784 0.564217443,2.35273369 L3.11300279,6.21972369 C3.85638192,7.31711738 5.13077459,7.89192632 6.45828355,7.68293161 L9.11325169,7.2648932 L9.16636798,5.85395846 L6.24586818,6.32427004 C5.44937276,6.42876739 4.70594385,6.11522634 4.28116288,5.48814423 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(11.462894, 8.672619) rotate(78.082127) translate(-11.462894, -8.672619) ",
  points: "9.5347022 6.66268074 13.4040286 6.65007927 13.3910866 10.682558 9.52176019 10.6951595"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.0261745,2.51138694 C10.832079,2.28305958 10.5894938,2.11182743 10.2983734,2.05478572 L3.50557882,0 L2.77777778,3.48173809 L9.18242697,5.42238689 L11.7054858,8.33333333 L13.8888889,5.8219464 L11.0261745,2.51138694 Z",
  id: "Path",
  fill: "#D0D0D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.8771921,16.1092999 L20.0891842,21.843863 C20.1418967,22.1068992 20.4053603,22.2647307 20.668824,22.2121531 L24.6210259,21.4229953 C24.8844895,21.3703683 25.0425776,21.1073322 24.9899145,20.844296 L24.0940985,16.6879992 C24.7791633,16.3723361 25.1480026,15.5831783 24.7791633,14.8466474 L21.8808655,8.90162579 C21.1431376,7.42851479 19.3514563,6.79718855 17.8759512,7.53376871 L17.8759512,7.53376871 L14.6088141,4.32451056 C14.3980135,4.11405204 14.0291743,4.11405204 13.8183737,4.32451056 L11.3943401,6.74461091 L11.2889645,7.69160027 C10.9727884,10.2169052 11.078164,12.7948371 11.6051407,15.3201421 L11.6051407,15.3201421 L18.8771921,16.1092999 Z",
  id: "Path",
  fill: "#F3705A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.94444444,13.8554268 C6.94444444,15.4116732 5.3661374,16.6666667 3.47219263,16.6666667 C1.57824785,16.6666667 0,15.4116262 0,13.8554268 C0,12.2992274 3.47225182,8.33333333 3.47225182,8.33333333 C3.47225182,8.33333333 6.94444444,12.2991803 6.94444444,13.8554268 Z",
  id: "Path",
  fill: "#CBB731"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.34561086,15.2777778 C1.04934156,15.2777778 0,14.2512336 0,12.9227213 C0,12.6811582 0.185181327,12.5 0.432109053,12.5 C0.679036779,12.5 0.864218107,12.6811582 0.864218107,12.9227213 C0.864218107,13.7681073 1.54319702,14.4323918 2.34566872,14.4323918 C2.59259645,14.4323918 2.77777778,14.61355 2.77777778,14.8551131 C2.77766204,15.0966196 2.59248071,15.2777778 2.34561086,15.2777778 Z",
  id: "Path",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.16666667,21.7252698 C4.16666667,22.7956031 3.24072266,23.6111111 2.08333333,23.6111111 C0.92594401,23.6111111 0,22.7446667 0,21.7252698 C0,20.6549365 2.08333333,18.0555556 2.08333333,18.0555556 C2.08333333,18.0555556 3.04820076,19.2594234 3.66467148,20.365947 C3.95405436,20.8853698 4.16666667,21.3833424 4.16666667,21.7252698 Z",
  id: "Path",
  fill: "#CBB731"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.50899716,23.6111111 C1.88171637,23.6111111 1.38888889,23.1182836 1.38888889,22.4462271 C1.38888889,22.3118158 1.47848243,22.2222222 1.61289374,22.2222222 C1.74730505,22.2222222 1.83689859,22.3118158 1.83689859,22.4462271 C1.83689859,22.849461 2.15053899,23.1631014 2.55377293,23.1631014 C2.64336647,23.1631014 2.77777778,23.2526949 2.77777778,23.3871063 C2.68818424,23.5215176 2.5985907,23.6111111 2.50899716,23.6111111 Z",
  id: "Path",
  fill: "#FFFFFF"
}))))));

var SvgDiesel = function SvgDiesel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiesel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diesel.91f44f56.svg";
export { ForwardRef as ReactComponent };